import InlineSVG from "react-inlinesvg";
import { useHistory } from "react-router-dom";
import { projectUrlId } from "../../../models/Project.js";
import { useCommentStore } from "../../../stores/commentStore";
import { useSudowriteStore } from "../../../stores/sudowriteStore";
import { useToast } from "../../ToastWrapper/index.js";
import { useAllFoldersStore } from "../store.js";
import { CleanCopyCardContainer } from "./styles.js";

export default function CleanCopyCard({ onClose }) {
  const history = useHistory();
  const { projectsById } = useAllFoldersStore();
  const { setToast } = useToast();
  const { setShowCleanCopyScreenOverlay } = useCommentStore((state) => state);
  const userData = useSudowriteStore((state) => state.userData);

  const handleShowMeClick = (e) => {
    e.preventDefault();
    userData.update({ hideCleanCopyShareMenuOnboarding: false });

    const projects = Object.values(projectsById)
      .filter((project) => !project.deleted && !project.archived)
      .sort((a, b) => new Date(b.last_active) - new Date(a.last_active));

    if (projects.length > 0) {
      const latestProject = projects[0];
      const url = projectUrlId(latestProject.firebase_id);

      history.push(url);

      // Function to look for and click the share button
      const findAndClickShareButton = () => {
        const shareButton = document.querySelector('[aria-label="Open Document Sharing Menu"]');
        if (shareButton) {
          setShowCleanCopyScreenOverlay(true);
          shareButton.click();
          return true;
        }
        return false;
      };

      // Try to find the button for up to 5 seconds
      let attempts = 0;
      const maxAttempts = 100; // 100 attempts * 50ms = 5 seconds max

      const tryFindButton = () => {
        if (findAndClickShareButton()) return;

        attempts++;
        if (attempts < maxAttempts) {
          setTimeout(() => requestAnimationFrame(tryFindButton), 50);
        }
      };

      requestAnimationFrame(tryFindButton);
    } else {
      setToast("No projects found. Create one to get started.");
    }
  };
  return (
    <CleanCopyCardContainer>
      <InlineSVG
        src="/assets/close.svg"
        className="close"
        onClick={(event) => {
          event.stopPropagation();
          onClose();
        }}
      />
      <div className="resources-title">
        <div className="resources-title-new"> New</div>
        <div className="resources-title-text">No-Hassle Beta Reader Feedback</div>
        <div className="resources-description">Stop making a zillion Google Docs copies. We have a better way.</div>
      </div>
      <div className="resources-container">
        <a
          className="resource"
          target="_blank"
          href="#"
          onClick={handleShowMeClick}
        >
          Show Me
        </a>
      </div>
    </CleanCopyCardContainer>
  );
}
